import {
  Textarea as ChakraTextarea,
  FormLabel,
  FormControl,
  TextareaProps as ChakraTextareaProps,
  FormErrorMessage,
} from '@chakra-ui/react'
import { forwardRef, ForwardRefRenderFunction } from 'react'
import { FieldError } from 'react-hook-form'

interface TextareaProps extends ChakraTextareaProps {
  name: string
  label?: string
  colorLabel?: string
  error?: FieldError
}

const TextAreaBase: ForwardRefRenderFunction<HTMLTextAreaElement, TextareaProps> = (
  { name, label, error = undefined, colorLabel = '#002147', ...rest },
  ref,
) => {
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel htmlFor={name} color={colorLabel}>
          {label}
        </FormLabel>
      )}
      <ChakraTextarea
        id={name}
        name={name}
        borderRadius="12"
        borderColor="gray.700"
        color={colorLabel}
        variant="filled"
        rows={6}
        _hover={{
          borderColor: colorLabel,
        }}
        _focus={{
          borderColor: colorLabel,
        }}
        ref={ref}
        {...rest}
      />

      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  )
}

export const TextArea = forwardRef(TextAreaBase)
